import { useState } from "react";
import { MaterialIcon } from "../components/MaterialIcon";

const FormSectionTile = ({ title, icon, description, children }) => {
  const [isExpanded, setIsExpanded] = useState(false);

  return (
    <div className={"form-section-tile"}>
      <div
        className={"form-section-tile__cover"}
        onClick={() => setIsExpanded(!isExpanded)}
      >
        <div className={"form-section-tile__icon"}>
          <MaterialIcon type={icon}></MaterialIcon>
        </div>
        <div className={"form-section-tile__tile-content"}>
          <div className={"form-section-tile__title"}>{title}</div>
          <div className={"form-section-tile__description"}>{description}</div>
        </div>

        <div
          className={`form-section-tile__trigger-icon ${
            isExpanded ? "form-section-tile__trigger-icon--expanded" : ""
          } `}
        >
          <MaterialIcon type={"expand_more"}></MaterialIcon>
        </div>
      </div>

      <div
        className={`form-section-tile__content ${
          isExpanded ? "form-section-tile__content--expanded" : ""
        }`}
      >
        {children}
      </div>
    </div>
  );
};

export { FormSectionTile };
